import React, { useState, useEffect } from "react";
import Navbar from "../../home/Navbar";
import Queryform from "../Queryform";
import Footer from "../../home/Footer";
import { useNavigate } from "react-router";
import { API_END_POINT } from "../Utils/Constant";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Loader from "../Loader";

const ChaughadiyaPanchang = () => {
    const [data, setData] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const navigate = useNavigate();
    // Fetch the data when the component mounts
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_END_POINT}panchang/choghadiyapanchang`);
                const result = await response.json();
                if (result.status === 200) {
                    setData(result.response); // Store the fetched data in state
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        fetchData();
    }, []);

    if (!data) {
        return <div className="flex justify-center items-center h-screen"><Loader/></div>; // Display a loading message until the data is fetched
    }

    // Function to determine row color based on type
    const getRowClass = (type) => {
        switch (type.toLowerCase()) {
            case "good":
                return "bg-green-100 text-gray-800";
            case "inauspicious":
                return "bg-red-100 text-gray-800";
            case "auspicious":
                return "bg-blue-100 text-gray-800";
            default:
                return "bg-gray-50 text-gray-800";
        }
    };
    const cards = [
        { title: "Chaughadiya", subtitle: "Muhurata", path: "/chaughadiya/panchang" },
        { title: "Hora", subtitle: "Muhurata", path: "/hora/panchang" },
        { title: "Daily", subtitle: "Panchang", path: "/daily/panchang" },
    ];


    return (
        <>
            <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
                <Navbar />

                {/* Header Section */}
                <div className="text-gray-900 flex flex-col  items-center mt-12">
                    <h1 className="text-3xl font-serif text-secondary uppercase text-center font-bold mb-4">Chaughadiya Panchang</h1>

                    <div className="w-11/12 lg:w-4/5 md:w-4/5 sm:w-11/12  flex items-center justify-between mt-5 bg-gradient-to-r from-success to-[#9034E9] p-4 mx-auto rounded-lg shadow-md">
                        <h2 className="text-white font-sans text-2xl font-bold">
                            Chaughadiya Panchang For {selectedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                        </h2>
                    </div>
                </div>
                {/* Main Content Container */}
                <div className="w-11/12 lg:w-4/5 md:w-4/5 sm:w-11/12  bg-white mx-auto mt-2 lg:p-6 md:p-6 sm:p-2 p-2 rounded-lg">
                    {/*  Day Muhurats */}
                    <h2 className="text-2xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md mb-4"> Day Muhurats</h2>
                    <div className="overflow-x-auto">
                        <Table className="w-full border-collapse shadow-md rounded-lg">
                            <Thead>
                                <Tr className="bg-success text-white text-lg">
                                    <Th className="px-6 py-3">Start</Th>
                                    <Th className="px-6 py-3">End</Th>
                                    <Th className="px-6 py-3">Muhurat</Th>
                                    <Th className="px-6 py-3">Type</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.day.map((item, index) => (
                                    <Tr key={index} className={`text-center text-lg ${getRowClass(item.type)}`}>
                                        <Td className="px-6 py-3">{new Date(item.start).toLocaleTimeString()}</Td>
                                        <Td className="px-6 py-3">{new Date(item.end).toLocaleTimeString()}</Td>
                                        <Td className="px-6 py-3 ">{item.muhurat}</Td>
                                        <Td className="px-6 py-3  uppercase">{item.type}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>

                    {/*  Night Muhurats */}
                    <h2 className="text-2xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md mt-8 mb-4"> Night Muhurats</h2>
                    <div className="overflow-x-auto">
                        <Table className="w-full border-collapse shadow-md rounded-lg">
                            <Thead>
                                <Tr className="bg-success text-white text-lg">
                                    <Th className="px-6 py-3">Start</Th>
                                    <Th className="px-6 py-3">End</Th>
                                    <Th className="px-6 py-3">Muhurat</Th>
                                    <Th className="px-6 py-3">Type</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.night.map((item, index) => (
                                    <Tr key={index} className={`text-center text-lg ${getRowClass(item.type)}`}>
                                        <Td className="px-6 py-3">{new Date(item.start).toLocaleTimeString()}</Td>
                                        <Td className="px-6 py-3">{new Date(item.end).toLocaleTimeString()}</Td>
                                        <Td className="px-6 py-3 ">{item.muhurat}</Td>
                                        <Td className="px-6 py-3 uppercase">{item.type}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>

                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 w-4/5 mx-auto mt-10 gap-6">
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            onClick={() => navigate(card.path)}
                            className="bg-gradient-to-br from-blue-500 to-purple-400 text-white text-center font-bold text-lg sm:text-xl p-8 rounded-lg shadow-lg cursor-pointer transform transition-transform hover:scale-105"
                        >
                            <h2>{card.title}</h2>
                            <p>{card.subtitle}</p>
                        </div>
                    ))}
                </div>
                <Queryform />
                <Footer />
            </section>
        </>
    );
};

export default ChaughadiyaPanchang;
